import src from "IMAGE";
export default { src, width: 429, height: 55, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAJUlEQVR42mMQEhKyBWInCQmJQDExMXdJSclQcXFxX2FhYScQBgBCmgQ2PAl0mwAAAABJRU5ErkJggg=="};
